import { Navigate, useSearchParams } from "react-router-dom";

export const RegisterRedirect = () => {
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email") ?? "";
  const nextSearchParams = new URLSearchParams(searchParams);
  nextSearchParams.delete("email");

  const query = nextSearchParams.toString();

  return (
    <Navigate
      to={`/signup/0${query ? `?${query}` : ""}`}
      replace
      state={{ email }}
    />
  );
};
